import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";

import * as serviceWorker from "./serviceWorker";
import App from "./App";
import "antd/dist/antd.css";

import { Provider } from "react-redux";

import { store, persistor } from "./services/redux/index";
import { PersistGate } from "redux-persist/integration/react";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor} loading={null}>
      <App />
    </PersistGate>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
